import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { dateTimeToPlainFormat, dateToPlainFormat } from '@/utils'

/**
 * レファレンスパラメータ
 * @export
 * @interface ReferenceListItem
 */
export interface ReferenceListItem {
  id: number
  question: string
  level: SystemCode
  managementNo: string
  answer: string
  createdDate: string
  answerStage: SystemCode
  keyword: string
  ndc1: string
  ndc1Edition: string
  ndc2: string
  ndc2Edition: string
  ndc3: string
  ndc3Edition: string
  researchType: string
  contentsType: string
  referenceMaterials: string
  answerProcess: string
  referee: string
  preResearch: string
  free: string
  contributor: string
  questionerUserId: number
  questionerName: string
  questionerKana: string
  questionerType: string
  questionerPhone: string
  questionerFax: string
  questionerMail: string
  questionerAddress: string
  receptionWindow: string
  receptionDate: string
  receptionMethod: string
  respondent: string
  responseDate: string
  responseMethod: string
  modelNumber: string
  memo: string
  database: SystemCode
  opac: SystemCode
  createdId: number
  updatedId: number
  createdAt: string
  updatedAt: string
}

export function ReferenceListItemFromJSON(json: any): ReferenceListItem {
  return ReferenceListItemFromJSONTyped(json)
}

export function ReferenceListItemFromJSONTyped(json: any): ReferenceListItem {
  return {
    id: exists(json, 'id') ? json.id : 0,
    question: exists(json, 'question') ? json.question : '',
    level: exists(json, 'level')
      ? SystemCodeFromJSON(json.level)
      : defaultSystemCode(),
    managementNo: exists(json, 'management_no') ? json.management_no : '',
    answer: exists(json, 'answer') ? json.answer : '',
    createdDate: exists(json, 'created_date')
      ? dateToPlainFormat(json.created_date)
      : '',
    answerStage: exists(json, 'answer_stage')
      ? SystemCodeFromJSON(json.answer_stage)
      : defaultSystemCode(),
    keyword: exists(json, 'keyword') ? json.keyword : '',
    ndc1: exists(json, 'ndc1') ? json.ndc1 : '',
    ndc1Edition: exists(json, 'ndc1_edition') ? json.ndc1_edition : '',
    ndc2: exists(json, 'ndc2') ? json.ndc2 : '',
    ndc2Edition: exists(json, 'ndc2_edition') ? json.ndc2_edition : '',
    ndc3: exists(json, 'ndc3') ? json.ndc3 : '',
    ndc3Edition: exists(json, 'ndc3_edition') ? json.ndc3_edition : '',
    researchType: exists(json, 'research_type') ? json.research_type : '',
    contentsType: exists(json, 'contents_type') ? json.contents_type : '',
    referenceMaterials: exists(json, 'reference_materials')
      ? json.reference_materials
      : '',
    answerProcess: exists(json, 'answer_process') ? json.answer_process : '',
    referee: exists(json, 'referee') ? json.referee : '',
    preResearch: exists(json, 'pre_research') ? json.pre_research : '',
    free: exists(json, 'free') ? json.free : '',
    contributor: exists(json, 'contributor') ? json.contributor : '',
    questionerUserId: exists(json, 'questioner_user_id')
      ? json.questioner_user_id
      : 0,
    questionerName: exists(json, 'questioner_name') ? json.questioner_name : '',
    questionerKana: exists(json, 'questioner_kana') ? json.questioner_kana : '',
    questionerType: exists(json, 'questioner_type') ? json.questioner_type : '',
    questionerPhone: exists(json, 'questioner_phone')
      ? json.questioner_phone
      : '',
    questionerFax: exists(json, 'questioner_fax') ? json.questioner_fax : '',
    questionerMail: exists(json, 'questioner_mail') ? json.questioner_mail : '',
    questionerAddress: exists(json, 'questioner_address')
      ? json.questioner_address
      : '',
    receptionWindow: exists(json, 'reception_window')
      ? json.reception_window
      : '',
    receptionDate: exists(json, 'reception_date')
      ? dateToPlainFormat(json.reception_date)
      : '',
    receptionMethod: exists(json, 'reception_method')
      ? json.reception_method
      : '',
    respondent: exists(json, 'respondent') ? json.respondent : '',
    responseDate: exists(json, 'response_date')
      ? dateToPlainFormat(json.response_date)
      : '',
    responseMethod: exists(json, 'response_method') ? json.response_method : '',
    modelNumber: exists(json, 'model_number') ? json.model_number : '',
    memo: exists(json, 'memo') ? json.memo : '',
    database: exists(json, 'database')
      ? SystemCodeFromJSON(json.database)
      : defaultSystemCode(),
    opac: exists(json, 'opac')
      ? SystemCodeFromJSON(json.opac)
      : defaultSystemCode(),
    createdId: exists(json, 'created_id') ? json.created_id : 0,
    updatedId: exists(json, 'updated_id') ? json.updated_id : 0,
    createdAt: exists(json, 'created_at')
      ? dateTimeToPlainFormat(json.created_at)
      : '',
    updatedAt: exists(json, 'updated_at')
      ? dateTimeToPlainFormat(json.updated_at)
      : ''
  }
}

export function ReferenceListItemToJSON(value: ReferenceListItem): any {
  return {
    id: value.id,
    question: value.question,
    level: value.level.code,
    management_no: value.managementNo,
    answer: value.answer,
    created_date: value.createdDate,
    answer_stage: value.answerStage.code,
    keyword: value.keyword,
    ndc1: value.ndc1,
    ndc1_edition: value.ndc1Edition,
    ndc2: value.ndc2,
    ndc2_edition: value.ndc2Edition,
    ndc3: value.ndc3,
    ndc3_edition: value.ndc3Edition,
    research_type: value.researchType,
    contents_type: value.contentsType,
    reference_materials: value.referenceMaterials,
    answer_process: value.answerProcess,
    referee: value.referee,
    pre_research: value.preResearch,
    free: value.free,
    contributor: value.contributor,
    questioner_user_id: value.questionerUserId,
    questioner_name: value.questionerName,
    questioner_kana: value.questionerKana,
    questioner_type: value.questionerType,
    questioner_phone: value.questionerPhone,
    questioner_fax: value.questionerFax,
    questioner_mail: value.questionerMail,
    questioner_address: value.questionerAddress,
    reception_window: value.receptionWindow,
    reception_date: value.receptionDate,
    reception_method: value.receptionMethod,
    respondent: value.respondent,
    response_date: value.responseDate,
    response_method: value.responseMethod,
    model_number: value.modelNumber,
    memo: value.memo,
    database: value.database.code,
    opac: value.opac.code
  }
}
